import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { OrderByPipe } from 'ngx-pipes';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import {
  AtMentionItem,
  AtMentionItemType,
} from '@app/core/_common/at-mention/at-mention.model';
import { debounceConfig } from '@app/core/_config/';
import { CardNotesService } from '@app/core/quotes/services/card-notes.service';
import { StaffService } from '@app/core/staff';

import { NdAttachmentPopupComponent } from '../nd-attachment-popup/nd-attachment-popup.component';

@Component({
  selector: 'cnc-nd-card-notes',
  templateUrl: './nd-card-notes.component.html',
  styleUrls: ['./nd-card-notes.component.scss'],
  providers: [OrderByPipe],
})
export class NdCardNotesComponent implements OnInit {
  @Input() design :any;

  selectedIndex :number = 0;
  selectedIndexStr :string = 'general';
  debounceTime :number = debounceConfig.time;
  isUpdating :boolean = false;

  commentHandler :any = {
    id: null,
    body: '',
    editable: false,
    filestoupload: [],
  };
  isImporting :boolean;
  cardNotes :any = {
    design: [],
    general: [],
    additional: [],
  };

  staff = [] as AtMentionItem[];

  constructor(
    private modal :NgbModal,
    private toastr :ToastrService,
    private orderBy :OrderByPipe,
    private cardNoteSvc :CardNotesService,
    private cd :ChangeDetectorRef,
    private translate :TranslateService,
    private staffService :StaffService,
  ) {}

  ngOnInit() {
    this.staffService.staff$.subscribe((staff) => {
      this.staff = staff.map<AtMentionItem>((user) => ({
        id: user.id,
        name: user.handle,
        type: 'user' as AtMentionItemType,
      }));
    });

    // console.log(this.design.assigned_comments);
    if (this.design.assigned_comments && this.design.assigned_comments.length > 0) {
      this.design.assigned_comments.forEach((row) => {
        row.filestoupload = [];
        if (row.meta) {
          try {
            row.meta = JSON.parse(row.meta);
          } catch (e) {}
        }
        if (row.meta) {
          if (row.meta.pm_note_type && row.meta.pm_note_type == 'general') {
            // row.note_type = 1;
            this.cardNotes.general.push(row);
          } else if (row.meta.pm_note_type && row.meta.pm_note_type == 'design') {
            // row.note_type = 2;
            this.cardNotes.design.push(row);
          }
        }
      });

      this.getAddlTabsWithComments();
      this.sortCardNotesByDate();
    }
  }

  private getAddlTabsWithComments() :void {
    this.cardNoteSvc.getCommentTabsByDesignId(this.design.id).subscribe(
      (resp) => {
        if (resp.length > 0) {
          resp.forEach((tab) => {
            tab.comments = [];
            this.design.assigned_comments.forEach((row) => {
              row.filestoupload = [];
              if (row.meta) {
                try {
                  row.meta = JSON.parse(row.meta);
                } catch (e) {}
              }
              if (row.meta && row.meta.pm_note_type == 'additional') {
                if (tab.id == row.comment_tab_id) {
                  tab.comments.push(row);
                }
              }
            });

            this.cardNotes.additional.push(tab);
          });
        }
      },
      (err) => {},
    );
  }

  private sortCardNotesByDate() :void {
    this.cardNotes.design = this.orderBy.transform(
      this.cardNotes.design,
      '-created_at',
    );
    this.cardNotes.general = this.orderBy.transform(
      this.cardNotes.general,
      '-created_at',
    );
    this.cardNotes.additional.forEach((tab) => {
      tab.comments = this.orderBy.transform(tab, '-created_at');
    });
  }

  onTabChanged(event) {
    this.selectedIndex = event.index;
    this.selectedIndexStr =
      event.index == 0 ? 'general' : event.index == 1 ? 'design' : 'additional';
    this.cd.detectChanges();
  }

  saveNote(note ?:any) {
    this.isImporting = true;
    const fd = new FormData();
    const meta = { pm_note_type: this.selectedIndexStr };
    fd.append('body', note ? note.body : this.commentHandler.body);
    fd.append('id', note ? note.id.toString() : '');
    fd.append('meta', JSON.stringify(meta));

    if (this.cardNotes.additional[this.selectedIndex - 2]) {
      fd.append(
        'comment_tab_id',
        this.cardNotes.additional[this.selectedIndex - 2].id,
      );
    }

    if (note) {
      note.filestoupload.forEach((file) => {
        fd.append('file[]', file.file);
      });
    } else {
      this.commentHandler.filestoupload.forEach((file) => {
        fd.append('file[]', file.file);
      });
    }

    this.cardNoteSvc.saveNote(this.design.id, fd).subscribe(
      (resp) => {
        this.toastr.success('Note added.');
        this.clearNoteForm(note);
        this.isImporting = false;
        if (note) {
          if (this.selectedIndexStr == 'additional') {
            const noteIdx :any = this.cardNotes.additional[
              this.selectedIndex - 2
            ].comments.findIndex((row) => row.id == note.id);
            this.cardNotes.additional[this.selectedIndex - 2].comments.splice(
              noteIdx,
              1,
              resp,
            );
          } else {
            const noteIdx :any = this.cardNotes[this.selectedIndexStr].findIndex(
              (row) => row.id == note.id,
            );
            this.cardNotes[this.selectedIndexStr].splice(noteIdx, 1, resp);
          }
        } else {
          if (this.selectedIndexStr == 'additional') {
            this.cardNotes.additional[this.selectedIndex - 2].comments.splice(
              0,
              0,
              resp,
            );
            this.design.assigned_comments_count += 1;
          } else {
            this.cardNotes[this.selectedIndexStr].splice(0, 0, resp);
            this.design.assigned_comments_count += 1;
          }
        }
        this.cd.detectChanges();
      },
      (err) => {
        this.toastr.error('Error adding note.');
        this.isImporting = false;
      },
    );
  }

  handleFileInput(event :any, note ?:any) {
    const files = Array.prototype.slice.call(event.target.files);
    // this.filestoupload = this.filestoupload.concat(files);
    const kani = this;
    let maxSizeError = false;

    files.forEach((file, idx) => {
      if (file.size > 26214400) {
        maxSizeError = true;
      } else {
        const ftu :any = {
          previewSrc: '',
          file: file,
        };
        if (note) {
          note.filestoupload.push(ftu);
        } else {
          this.commentHandler.filestoupload.push(ftu);
        }
        // if (file.type.toString().search('image') >= 0) {
        // 	const index = note ? note.filestoupload.length - 1 : this.commentHandler.filestoupload.length - 1;
        // 	var fReader = new FileReader();
        // 	fReader.readAsDataURL(file);
        // 	fReader.onload = function (e: any) {
        // 		if (note) {
        // 			kani.commentHandler.filestoupload[index].previewSrc = e.target.result;
        // 		} else {
        // 			note.filestoupload[index].previewSrc = e.target.result;
        // 		}
        // 	};
        // }
      }
    });
    if (maxSizeError) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });
    }
    event.target.value = '';
  }

  clearNoteForm(note ?:any) {
    if (note) {
      note.filestoupload = [];
      note.editable = false;
    } else {
      this.commentHandler = {
        id: null,
        body: '',
        editable: false,
        filestoupload: [],
      };
    }
  }

  viewAttachment(attachment) {
    const data :any = {
      url: attachment.url,
      type: attachment.filetype,
      name: attachment.filename,
    };
    const modalRef = this.modal.open(NdAttachmentPopupComponent, {
      windowClass: 'myCustomModalClass',
    });
    modalRef.componentInstance.attachment = data;
  }

  deleteAttachment(note, attachmentId :number, idx :number) {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete attachment ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        const data = {
          id: attachmentId,
        };

        if (data.id != null) {
          this.cardNoteSvc.deleteAttachment(this.design.id, data).subscribe(
            (resp) => {
              note.assigned_attachments.splice(idx, 1);
              this.toastr.success('Successfully deleted attachment.', 'Success');
              this.cd.detectChanges();
            },
            (err) => {},
          );
        }
      }
    });
  }

  deleteComment(note, idx) {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete note ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        const data = {
          id: note.id,
        };
        if (data.id != null) {
          this.cardNoteSvc.deleteComment(this.design.id, data).subscribe(
            (resp) => {
              if (resp && resp.id) {
                if (note.comment_tab_id) {
                  this.cardNotes.additional.forEach((tab) => {
                    if (tab.id == note.comment_tab_id) {
                      tab.comments.splice(idx, 1);
                    }
                  });
                } else {
                  this.cardNotes[this.selectedIndexStr].splice(idx, 1);
                }

                this.design.assigned_comments_count -= 1;
                this.toastr.success('Successfully deleted note.', 'Success');
              }
              this.cd.detectChanges();
            },
            (err) => {},
          );
        }
      }
    });
  }

  handleAddlInput(event :KeyboardEvent) :void {
    this.isUpdating = true;
    event.stopPropagation();
  }

  createCommentTab() :void {
    const data = {
      title: 'Title',
    };

    this.cardNoteSvc.saveCommentTab(this.design.id, data).subscribe(
      (resp) => {
        this.cardNotes.additional.push({
          id: resp.id,
          title: resp.title,
          comments: [],
        });

        this.selectedIndex = 1 + this.cardNotes.additional.length;
        this.cd.detectChanges();
      },
      (err) => {},
    );
  }

  handleUpdateCommentTab(index :number, commentTab :any) :void {
    const data = {
      id: commentTab.id,
      title: commentTab.title,
    };

    this.cardNoteSvc.saveCommentTab(this.design.id, data).subscribe(
      (resp) => {
        if (resp && resp.id) {
          this.cardNotes.additional[index].title = resp.title;
          this.toastr.success('Successfully updated the tab title.', 'Success');
        }
        this.isUpdating = false;
        this.cd.detectChanges();
      },
      (err) => {},
    );
  }

  deleteCommentTab(tabId :number) :void {
    Swal.fire({
      title: 'Confirm delete?',
      text: 'Delete tab?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result) {
        const deleted = this.cardNotes.additional[tabId];
        this.cardNoteSvc.deleteCommentTab(deleted.id).subscribe(
          (resp) => {
            if (resp) {
              this.cardNotes.additional.splice(tabId, 1);
              this.design.assigned_comments_count -= deleted.comments.length;
              this.toastr.success('Successfully deleted tab.', 'Success');
            }
            this.selectedIndex -= 1;
            this.cd.detectChanges();
          },
          (err) => {},
        );
      }
    });
  }
}
